export enum UserType {
	GOT_IT = 'GOT_IT',
	KY_APPOINTMENT = 'KY_APPOINTMENT',
	KY_INSTANT = 'KY_INSTANT',
	OTHER = 'OTHER'
}

export enum SenderType {
	USER = 'USER',
	STUDENT = 'STUDENT',
	SUPPORT = 'SUPPORT'
}

export interface User {
	id: number | string;
	name: string;
	surname: string;
	avatar: string;
	type?: UserType;
	title?: string;
	grade?: string;
	unreadCount?: number;
	isTopRanked?: boolean | null;
}

export interface Message {
	id: number;
	content?: string;
	date: string;
	time: string;
	sender: SenderType;
	senderType?: string;
	senderUser?: User;
	isRead: boolean;
}

export interface Conversation {
	id: number;
	title: string;
	description?: string;
	lastMessage?: string;
	date?: string;
	unreadCount?: number;
	messages: Message[];
	user: User;
}

export interface Support {
	id?: number | string;
	name?: string;
	surname?: string;
	avatar?: string;
	title?: string;
	unreadCount?: number;
	isTopRanked?: boolean | null;
}

export interface Student {
	id?: number | string;
	name?: string;
	surname?: string;
	avatar?: string;
	grade?: string;
	unreadCount?: number;
	unreadMessageCount?: string;
	isTopRanked?: boolean | null;
}

export interface SupportTopic {
	id?: string | number;
	title?: string;
	description?: string;
	date?: string;
	icon?: string;
	unreadCount?: number;
	isRead?: boolean;
	completed?: boolean;
}

export type MessageTab = 'student' | 'parent';
